export {
  ASSIGNEE_POOL_TYPE as TEMPLATE_ASSIGNEE_RULE,
  ASSIGNEE_POOL_TYPES as TEMPLATE_ASSIGNEE_RULES,
  DEFAULT_ASSIGNEE_POOL_TYPE as DEFAULT_TEMPLATE_ASSIGNEE_RULE,
} from './assigneePool.config.js'

/** Default due-date offset (days) for a new template row. */
export const DEFAULT_TEMPLATE_DUE_DATE_OFFSET = 14

/** Default due-date offset (days) for a new template sub-task row. */
export const DEFAULT_TEMPLATE_TASK_DUE_DATE_OFFSET = 0

/** Stable ids for locked system templates (mirrors server globalValues.tickets.systemKeys). */
export const TEMPLATE_SYSTEM_KEY = Object.freeze({
  RENT_INCREASE: 'rent_increase',
})

/** Templates whose subtasks are built at runtime (e.g. one task per contract). */
export function templateHasRuntimeTasks(systemKey) {
  return systemKey === TEMPLATE_SYSTEM_KEY.RENT_INCREASE
}
